module.exports = __webpack_public_path__ + "static/media/unmute.4c0b1820.svg";